export const SET_CART_EMAIL = 'SET_CART_EMAIL';
